var map = {
	"./cmd-key.png": 7273,
	"./ctrl-key.png": 8321,
	"./delete-key.png": 2215,
	"./esc-key.png": 3427,
	"./fn-key.png": 5689,
	"./opt-key.png": 7506,
	"./right-tab-key.png": 6500,
	"./shift-key.png": 8352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6686;